import * as React from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 8,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#531edc",
      backgroundColor: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundColor: "#fff",
        borderColor:"#531edc !important",
        border: "2px solid #531edc !important",
        borderRadius:'50%',
        width: 27,
        height: 27,
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          "#531edc"
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#531edc !important",
        height: "15px",
        width: "52px !important",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#fff",
    borderColor:"#531edc !important",
    border: "2px solid #531edc !important",
    width: 27,
    height: 27,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        "#531edc"
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "#a3a5a8",
    borderRadius: 20 / 2,
  },
}));

export default function MDSwitch() {
  return (
    <div style={{ direction: "ltr" }}>
      <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} defaultChecked />} label="" />
    </div>
    //   <FormControlLabel
    //     control={<Android12Switch defaultChecked />}
    //     label="Android 12"
    //   />
    //   <FormControlLabel
    //     control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
    //     label="iOS style"
    //   />
    //   <Stack direction="row" spacing={1} alignItems="center">
    //     <Typography>Off</Typography>
    //     <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
    //     <Typography>On</Typography>
    //   </Stack>
  );
}
